export default __webpack_public_path__ + "static/media/CU.a04c3938.svg";